import React from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  message,
  Modal,
  Form,
  Select,
  DatePicker,
  Tooltip,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import config from "../config";
import { DeleteFilled, SearchOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import WASLCompanyStore from "../store/WASLCompanyStore";
import DeleteConfirm from "./DeleteConfirm";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import CountryStore from "../store/CountryStore";
import { hasFeature } from "../utils/componentVisibility";
const features = {
  showWaslPermission: hasFeature("showWaslPermission")
};
const { Option } = Select;

const dateFormat = "YYYY-MM-DD";
const cMargins = {
  name: 100,
  identityNo: -50,
  reply: 0,
  commercialRecordNo: -100,
  commercialRecordIssueDate: -250,
  phoneNo: 20,
  extensionNo: -40,
  emailAddress: 50,
  managerName: 15,
  managerPhone: -20,
  managerMobile: -35,
  activity: -20,
  action: -15,
};

let widthAdderFunc = (arr) => {
  let array = arr;
  array.forEach((val) => {
    val.width =
      Number(val.title.length) * 11 +
      (cMargins[val.dataIndex] ? cMargins[val.dataIndex] : 0);
  });

  return arr;
};
class WASLCompanyList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);

    this.waslCompanyStore = new WASLCompanyStore(this);
    this.countryStore = new CountryStore(this);

    this.state = {
      showWASLRegistration: false,
      exportLoading: false,
      loading: false,
      offset: 0,
      limit: 50,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      loadList: 0,
      Company: true,
      Individual: false,
      cname: "",
      identityNo: "",
      crNo: "",
      loadData: 0,
      companyId: "",
      SFDAActivity: false,
      UcompanyId: "",
      cid: "",
      Individual2: true,
      showAlertModal: false,
      searchField: "",

      waslInquiryPopup: false,
    };

    this.columns = widthAdderFunc([
      {
        title: context.translate("_ACCOUNT_"),
        // fixed: "left",
        dataIndex: "name",
        key: "name",

        ellipsis: true,
      },
      {
        title: context.translate("_IDENTITY_NUMBER_"),
        dataIndex: "identityNo",
        key: "identityNo",

        ellipsis: true,
      },
      {
        title: context.translate("_COMMERCIAL_RECORD_NUMBER_"),
        dataIndex: "commercialRecordNo",
        key: "commercialRecordNo",
        ellipsis: true,
      },
      {
        title: context.translate("_COMMERCIAL_RECORD_ISSUE_DATE_"),
        dataIndex: "commercialRecordIssueDate",
        key: "commercialRecordIssueDate",
        ellipsis: true,
      },
      {
        title: context.translate("_FLEET_DASHBORD_NEWPOI_PHONE_"),
        dataIndex: "phoneNo",
        key: "phoneno",
        ellipsis: true,
      },
      {
        title: context.translate("_EXTENSION_NUMBER_"),
        dataIndex: "extensionNo",
        key: "extensionNumber",
        ellipsis: true,
      },
      {
        title: context.translate("_EMAIL_ID_"),
        dataIndex: "emailAddress",
        key: "emailId",
        ellipsis: true,
      },
      {
        title: context.translate("_MANAGER_NAME_"),
        dataIndex: "managerName",
        key: "managerName",
        ellipsis: true,
      },
      {
        title: context.translate("_MANAGER_PHONE_"),
        dataIndex: "managerPhone",
        key: "managerPhone",
        ellipsis: true,
      },
      {
        title: context.translate("_MANAGER_MOBILE_"),
        dataIndex: "managerMobile",
        key: "managerMobile",
        ellipsis: true,
      },
      {
        title: context.translate("_REPLY_"),
        dataIndex: "reply",
        key: "reply",
        ellipsis: true,
      },
      {
        title: context.translate("_WASL_KEY_"),
        dataIndex: "waslKey",
        key: "waslKey",
        ellipsis: true,
      },
      {
        title: context.translate("_ACTIVITY_"),
        dataIndex: "activity",
        key: "activity",
        ellipsis: true,
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        // fixed: "right",
        ellipsis: true,

        render: (_, record) => {
          return (
            <>
              <Space>
                {(Number(this.props.getUserData().isadmin) === -1 ||
                  Number(this.props.getUserData().isadmin) === 3) && (
                    <>
                      <Tooltip
                        // title="WASL Status"
                        title={this.context.translate("_WASL_STATUS_")}
                        placement="bottom"
                        color={config.tooltipColorEdit}
                      >
                        <SearchOutlined
                          onClick={async () => {
                            const response =
                              await this.waslCompanyStore.getWASLCompanyStatus(
                                record
                              );

                            if (response) {
                              this.setState({
                                waslInquiryPopup: true,
                                showAlertModal: false,
                                loadData: 1,
                              });
                            } else {
                              this.setState({
                                waslInquiryPopup: false,
                                showAlertModal: true,
                                loadData: 1,
                              });
                            }
                          }}
                        />
                      </Tooltip>
                      {features.showWaslPermission ? this.props.canDelete("waslaccount") &&
                        <DeleteConfirm
                          onConfirm={(e) => {
                            this.onDelete(record);
                          }}
                        >
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                            }}
                          >
                            <Tooltip
                              // title="Delete"
                              title={this.context.translate(
                                "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                              )}
                              placement="bottom"
                              color={config.tooltipColorDelete}
                            >
                              <DeleteFilled style={{ color: config.deleteColor }} />
                            </Tooltip>
                          </Link>
                        </DeleteConfirm> : <DeleteConfirm
                          onConfirm={(e) => {
                            this.onDelete(record);
                          }}
                        >
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <Tooltip
                            // title="Delete"
                            title={this.context.translate(
                              "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                            )}
                            placement="bottom"
                            color={config.tooltipColorDelete}
                          >
                            <DeleteFilled style={{ color: config.deleteColor }} />
                          </Tooltip>
                        </Link>
                      </DeleteConfirm>}
                    </>
                  )}
              </Space>
            </>
          );
        },
      },
    ]);
    this.formRef = React.createRef();
  }
  async componentDidMount() {

    const searchField_waslcompany_session = sessionStorage?.getItem('searchField_waslcompany_session');
    if (searchField_waslcompany_session) {
      const { searchField } = JSON.parse(searchField_waslcompany_session);
      this.setState({ searchField });
    }

    await this.countryStore.getCountry();
    this.setState({ pageSize: 50 });
    if (config.pythonReport === 1) {
      await this.waslCompanyStore.getwaslactivity();
    }
    this.handleSearch();
    this.setState({ loadList: 1 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      Number(this.props.getUserData().isadmin) === 0 ||
      Number(this.props.getUserData().isadmin) === 1
    ) {
      this.props.navigate("/login");
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      loadList: 1,
      currentPage: 1,
      pageSize: 50,
    });

    const getData = await this.waslCompanyStore.getCompanyInfo(comp.value);
    await this.setState({ getData: getData });

    await this.formRef.current.setFieldsValue({ phoneNo: getData.contact1No });
    await this.formRef.current.setFieldsValue({
      emailAddress: getData.contact1Email,
      identityNo: getData.identityNo,
      DOBFormat: getData.dobFormat,
    });

    this.formRef.current.setFieldsValue({
      commercialRecordIssueDate: getData.commercialRecordIssueDate
        ? dayjs(getData.commercialRecordIssueDate)
        : null,
      dobindividual: getData.dob ? dayjs(getData.dob) : null,
      commercialRecordNo: getData.commercialRecordNo,
    });
    await this.formRef.current.setFieldsValue({
      managerName: getData.contact1,
    });
    await this.formRef.current.setFieldsValue({
      managerPhone: getData.contact1No,
    });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.waslCompanyStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      UcompanyId:
        this.props.getUserData().isadmin === 3
          ? this.props.getUserData().userCompanyId
          : 0,
    });

    this.setState({ loading: false });
    await this.setState({ loadList: 1 });
  }

  searchInput = async (e) => {
    const value = e.target.value;

    sessionStorage.setItem('searchField_waslcompany_session', JSON.stringify({
      searchField: value
    }));

    await this.setState({ searchField: value });
    if (value.length > 2) {
      await this.waslCompanyStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1, companyLoading: false });
    } else if (value.length === 0) {
      await this.waslCompanyStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
      });
      await this.setState({
        loadList: 1,
        companyLoading: false,
        currentPage: 1,
      });
    }
  };

  async inputSearchButton() {
    if (this.state.searchField.length > 0) {
      await this.waslCompanyStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
      });
    }
    await this.setState({ loadList: 1 });
  }

  registerAccountType = (value) => {
    if (value === "Individual") {
      this.setState({ Individual: true });
      this.setState({ Individual2: false });

      this.setState({ Company: false });
    } else if (value === "Company") {
      this.setState({ Individual: false });
      this.setState({ Individual2: false });

      this.setState({ Company: true });
    }
  };

  onWASLRegistrationFinish = async (value) => {
    const data = {
      ...value,
      userId: 1,
      commercialRecordIssueDate:
        value?.commercialRecordIssueDate?.format(dateFormat),
      companyId: this.state.companyId,
      dobindividual: value?.dobindividual?.format(dateFormat),
    };

    const response = await this.waslCompanyStore.registerCompany(data);
    if (response?.success === "S" || response?.data?.success === "S") {
      message.success(response.data.message);
      await this.handleSearch();
    } else {
      message.error(response.data.message);
      await this.handleSearch();
    }
    if (response.data.message) {
      this.setState({ showWASLRegistration: false });
      this.formRef.current?.resetFields();
    }
  };

  async onDelete(record) {
    const response = await this.waslCompanyStore.deleteRecord({
      Id: record.Id,
      companyId: record.companyId,
      waslkey: record.waslKey,
      userId: this.props.getUserData().userId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  validatePhoneNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  validateNumber = (value, field) => {
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  render() {
    const { referenceNumber, name, registrationDate, isValid } =
      this.waslCompanyStore?.inquiryStatus || {};

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <Input
                  style={{ width: 400 }}
                  // placeholder="Account Name,Identity Number,CR Number"
                  placeholder={this.context.translate(
                    "_Account_Name_Identity_Number_CR_Number_"
                  )}
                  value={this.state.searchField}
                  onChange={(e) => {
                    this.searchInput(e)

                  }

                  }
                />

                {/* <Button
                  type="primary"
                  onClick={async () => await this.inputSearchButton()}
                >
                  <SearchOutlined />
                </Button> */}
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Link to={"/companylist"}>
                  <Button className="addButtonClass">
                    {this.context.translate("_BACK_")}
                  </Button>
                </Link>
                {features.showWaslPermission ? this.props.canCreate("waslaccount") && <Button
                  className="addButtonClass"
                  // type="primary"
                  onClick={() => this.setState({ showWASLRegistration: true })}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  />
                  {this.context.translate("_REGISTER_")}
                </Button> : <Button
                  className="addButtonClass"
                  // type="primary"
                  onClick={() => this.setState({ showWASLRegistration: true })}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  />
                  {this.context.translate("_REGISTER_")}
                </Button>}

                <Button
                  className={`downloadExcelButton ${this.state.exportLoading ? "downloadExcelButtonLoading" : ""
                    }`}
                  loading={this.state.exportLoading}
                  disabled={
                    this.waslCompanyStore?.WASLCompanyArray.length > 0
                      ? false
                      : true
                  }
                  onClick={async () => {
                    const result = [];
                    await this.columns.map((obj) => result.push(obj.dataIndex));

                    var getData = {
                      companyId: this.state.cid,
                      UcompanyId: this.state.UcompanyId,
                      colList: result,
                      searchField: this.state.searchField,
                    };

                    this.setState({ exportLoading: true });

                    try {
                      await this.waslCompanyStore.exportExcel(getData);
                    } catch (error) {
                      message.error("Failed to export Excel");
                      this.setState({ exportLoading: false });
                    } finally {
                      this.setState({ exportLoading: false });
                    }

                  }}
                >
                  <Tooltip title="Download Excel" placement="bottom">
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            total={this.waslCompanyStore?.total}
            pageSize={this.state.pageSize}
            columns={this.columns}
            // dataSource={this.dataSource}
            dataSource={this.waslCompanyStore?.WASLCompanyArray}
            loading={this.waslCompanyStore?.loading}
            onChange={this.handleTableChange}
            scroll={{
              x: 1800,
            }}
          />
        </div>
        {/* <Modal
          bodyStyle={{ height: "645px" }}
          className="formShowModal"
          title={this.context.translate("_WASL_REGISTRATION_")}
          destroyOnClose={true}
          open={this.state.showWASLRegistration}
          onCancel={() => this.setState({ showWASLRegistration: false })}
          footer={null}
          width={665}
          centered
          // onOk={}
        > */}
        <Drawer
          className="accountFormDrawer"
          width={716}
          closeIcon={false}
          open={this.state.showWASLRegistration}
          placement={
            this.context.locale.language === "arabic" ? "left" : "right"
          }
          title={
            <div className="formTitle">
              {this.context.translate("_WASL_REGISTRATION_")}
              <p className="formDescription">
                {this.context.translate("_DRIVER_ADD_DESC_")}
              </p>
            </div>
          }
          footer={false}
          maskClosable={false}
          onOk={() => this.setState({ showWASLRegistration: false })}
          onCancel={() =>
            this.setState({
              showWASLRegistration: false,
            })
          }
        >
          <Form
            ref={this.formRef}
            layout="vertical"
            name="companyFrm"
            onFinish={this.onWASLRegistrationFinish}
            style={{ maxWidth: "100%", padding: 0, height: "92%" }}
            className="formClass"
          >
            <Row className="overflowFormInputs">
              <Col span={12} className="waslFormClass">
                <Form.Item
                  className="formFieldsStyle"
                  name="companyId"
                  label={
                    <span>
                      {this.context.translate("_ACCOUNT_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <CompanyAutocomplete
                    onChange={(value) => {
                      this.handleChange(value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="registerAccountType"
                  label={
                    <span>
                      {this.context.translate("_REGISTRATION_TYPE_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_REGISTRATION_TYPE_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Select
                    placeholder={this.context.translate("_SELECT_TYPE_")}
                    onChange={(value) => this.registerAccountType(value)}
                    autoClearSearchValue
                  >
                    <Select.Option value="Company">
                      {this.context.translate("_COMPANY_")}
                    </Select.Option>
                    <Select.Option value="Individual">
                      {this.context.translate("_INDIVIDUAL_")}
                    </Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="identityNo"
                  label={
                    <span>
                      {this.context.translate("_IDENTITY_NUMBER_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_IDENTITY_NUMBER_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Input
                    onChange={(e) =>
                      this.validateNumber(e.target.value, "identityNo")
                    }
                  />
                </Form.Item>

                {this.state.Company && (
                  <>
                    <Form.Item
                      className="formFieldsStyle"
                      name="commercialRecordNo"
                      label={
                        <span>
                          {this.context.translate("_COMMERCIAL_RECORD_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_COMMERCIAL_RECORD_NUMBER_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="commercialRecordIssueDate"
                      label={
                        <span>
                          {this.context.translate(
                            "_COMMERCIAL_RECORD_ISSUE_DATE_"
                          )}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_COMMERCIAL_RECORD_ISSUE_DATE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", height: "40px" }}
                        format={dateFormat}
                      />
                    </Form.Item>
                  </>
                )}

                <Form.Item
                  name="extensionNo"
                  label={this.context.translate("_EXTENSION_NUMBER_")}
                >
                  <Input />
                </Form.Item>

                {config.pythonReport == 1 ? <Form.Item
                  className="formFieldsStyle"
                  name="activity"
                  label={
                    <span>
                      {this.context.translate("_ACTIVITY_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate("_ACTIVITY_")} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Select
                    showSearch
                    autoClearSearchValue
                    onSelect={(val) =>
                      val === "SFDA"
                        ? this.setState({ SFDAActivity: true })
                        : this.setState({ SFDAActivity: false })
                    }
                    options={
                      this.waslCompanyStore.waslactivity?.map((item) => ({
                        value: item.name,   // what you want to store
                        label: item.name,   // what you want to show
                      }))
                    }
                  />
                </Form.Item> : <Form.Item
                  className="formFieldsStyle"
                  name="activity"
                  initialValue={"DEFAULT"}
                  label={
                    <span>
                      {this.context.translate("_ACTIVITY_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_ACTIVITY_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Select
                    autoClearSearchValue
                    onSelect={(val) =>
                      val === "SFDA"
                        ? this.setState({ SFDAActivity: true })
                        : this.setState({ SFDAActivity: false })
                    }
                  >
                    <Select.Option value="DEFAULT">
                      {this.context.translate("_DEFAULT_")}
                    </Select.Option>
                    <Select.Option value="TOW_CAR">
                      {this.context.translate("_TOW_CAR_")}
                    </Select.Option>
                    <Select.Option value="SPECIALITY_TRANSPORT">
                      {this.context.translate("_SPECIALITY_TRANSPORT_")}
                    </Select.Option>
                    <Select.Option value="BUS_RENTAL">
                      {this.context.translate("_BUS_RENTAL_")}
                    </Select.Option>
                    <Select.Option value="EDUCATIONAL_TRANSPORT">
                      {this.context.translate("_EDUCATIONAL_TRANSPORT_")}
                    </Select.Option>
                    <Select.Option value="SFDA">
                      {this.context.translate("_SFDA_")}
                    </Select.Option>
                    <Select.Option value="INTERNATIONAL_TRANSPORT">
                      INTERNATIONAL TRANSPORT
                    </Select.Option>
                  </Select>
                </Form.Item>
                }
              </Col>

              <Col span={12} className="waslFormClass">
                {this.state.SFDAActivity && (
                  <>
                    <Form.Item
                      className="formFieldsStyle"
                      name="sfdaCompanyActivity"
                      // initialValue={"DEFAULT"}
                      label={
                        <span>
                          {this.context.translate("_SFDA_COMPANY_ACTIVITY_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_SFDA_COMPANY_ACTIVITY_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Select
                        placeholder={this.context.translate(
                          "_SELECT_ACTIVITY_"
                        )}
                      >
                        <Select.Option value="STORE">STORE</Select.Option>
                        <Select.Option value="TRANSPORT">
                          TRANSPORT
                        </Select.Option>
                        <Select.Option value="STORE_TRANSPORT">
                          STORE TRANSPORT
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="sfdaLicenseNumber"
                      label={
                        <span>
                          {this.context.translate("_SFDA_LICENSE_NUMBER_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_SFDA_LICENSE_NUMBER_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </>
                )}

                {this.state.Individual && (
                  <>
                    <Form.Item
                      className="formFieldsStyle"
                      name="DOBFormat"
                      label={
                        <span>
                          {this.context.translate("_DOB_FORMATE_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DOB_FORMATE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Select>
                        <Select.Option value="Hijri">
                          {this.context.translate("_HIJRI_")}
                        </Select.Option>
                        <Select.Option value="Gregorian">
                          {this.context.translate("_GREGORIAN_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      name="dobindividual"
                      label={
                        <span>
                          {this.context.translate("_DOB_LABEL_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DOB_LABEL_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", height: "40px" }}
                        format={dateFormat}
                        disabledDate={(current) => {
                          return current && current > dayjs();
                        }}
                      />
                    </Form.Item>
                  </>
                )}

                {/* <div style={{ display: this.state.Individual2 ? "" : "none" }}> */}
                {this.state.Individual2 && (
                  <>
                    {" "}
                    <Form.Item
                      className="formFieldsStyle"
                      name="DOBFormat"
                      label={
                        <span>
                          {this.context.translate("_DOB_FORMATE_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DOB_FORMATE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Select>
                        <Select.Option value="Hijri">
                          {this.context.translate("_HIJRI_")}
                        </Select.Option>
                        <Select.Option value="Gregorian">
                          {this.context.translate("_GREGORIAN_")}
                        </Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item
                      className="formFieldsStyle"
                      name="dobindividual"
                      label={
                        <span>
                          {this.context.translate("_DOB_LABEL_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_DOB_LABEL_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", height: "40px" }}
                        format={dateFormat}
                        disabledDate={(current) => current.isAfter()}
                      />
                    </Form.Item>
                  </>
                )}
                {/* </div> */}

                <Form.Item
                  className="formFieldsStyle"
                  label={
                    <span>
                      {this.context.translate("_MOBILE_NUMBER_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_MOBILE_NUMBER_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <Space.Compact style={{ width: "100%" }}>
                    <Form.Item
                      name="countryCode"
                      noStyle
                      initialValue={config.countryCode}
                    >
                      <Select
                        style={{ width: "55%", borderRadius: "5px" }}
                        showSearch
                        filterOption={(inputValue, option) => {
                          if (option.children) {
                            return (
                              option.children
                                .toLowerCase()
                                .indexOf(inputValue.toLowerCase()) >= 0
                            );
                          }
                        }}
                      >
                        {this.countryStore?.country?.map((country) => {
                          return (
                            <Option
                              key={country.countryId}
                              value={parseInt(country.countryId)}
                            >
                              {country.countryCode}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="phoneNo"
                      noStyle
                      rules={[
                        {
                          required: true,
                          pattern: /^\d{8,10}$/,
                          message: this.context.translate(
                            "_Enter_7_or_10_Digit_Number_"
                          ),
                        },
                      ]}
                      required={false}
                    >
                      <Input
                        style={{ width: "100%" }}
                        onChange={(e) =>
                          this.validatePhoneNumber(e.target.value, "phoneNo")
                        }
                      />
                    </Form.Item>
                  </Space.Compact>
                </Form.Item>

                <Form.Item
                  className="formFieldsStyle"
                  name="emailAddress"
                  label={
                    <span>
                      {this.context.translate("_EMAIL_ID_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_EMAIL_ID_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                      type: "email",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                {this.state.Company && (
                  <>
                    <Form.Item
                      className="formFieldsStyle"
                      name="managerName"
                      label={
                        <span>
                          {this.context.translate("_MANAGER_NAME_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_MANAGER_NAME_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      label={
                        <span>
                          {this.context.translate("_MANAGER_PHONE_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_MANAGER_PHONE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Space.Compact style={{ width: "100%" }}>
                        <Form.Item
                          name="managerPhoneCountryCode"
                          noStyle
                          initialValue={config.countryCode}
                        >
                          <Select
                            style={{ width: "55%", borderRadius: "5px" }}
                            showSearch
                            filterOption={(inputValue, option) => {
                              if (option.children) {
                                return (
                                  option.children
                                    .toLowerCase()
                                    .indexOf(inputValue.toLowerCase()) >= 0
                                );
                              }
                            }}
                          >
                            {this.countryStore?.country?.map((country) => {
                              return (
                                <Option
                                  key={country.countryId}
                                  value={parseInt(country.countryId)}
                                >
                                  {country.countryCode}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name="managerPhone"
                          noStyle
                          rules={[
                            {
                              required: true,
                              pattern: /^\d{8,10}$/,
                              message: this.context.translate(
                                "_Enter_7_or_10_Digit_Number_"
                              ),
                            },
                          ]}
                          required={false}
                        >
                          <Input
                            style={{ width: "100%" }}
                            onChange={(e) =>
                              this.validatePhoneNumber(
                                e.target.value,
                                "managerPhone"
                              )
                            }
                          />
                        </Form.Item>
                      </Space.Compact>
                    </Form.Item>

                    <Form.Item
                      className="formFieldsStyle"
                      label={
                        <span>
                          {this.context.translate("_MANAGER_MOBILE_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_MANAGER_MOBILE_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <Space.Compact style={{ width: "100%" }}>
                        <Form.Item
                          name="managerMobileCountryCode"
                          noStyle
                          initialValue={config.countryCode}
                        >
                          <Select
                            style={{ width: "55%", borderRadius: "5px" }}
                            showSearch
                            filterOption={(inputValue, option) => {
                              if (option.children) {
                                return (
                                  option.children
                                    .toLowerCase()
                                    .indexOf(inputValue.toLowerCase()) >= 0
                                );
                              }
                            }}
                          >
                            {this.countryStore?.country?.map((country) => {
                              return (
                                <Option
                                  key={country.countryId}
                                  value={parseInt(country.countryId)}
                                >
                                  {country.countryCode}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name="managerMobile"
                          noStyle
                          rules={[
                            {
                              required: true,
                              pattern: /^\d{8,10}$/,
                              message: this.context.translate(
                                "_Enter_7_or_10_Digit_Number_"
                              ),
                            },
                          ]}
                          required={false}
                        >
                          <Input
                            style={{ width: "100%" }}
                            onChange={(e) =>
                              this.validatePhoneNumber(
                                e.target.value,
                                "managerMobile"
                              )
                            }
                          />
                        </Form.Item>
                      </Space.Compact>
                    </Form.Item>
                  </>
                )}
              </Col>
            </Row>
            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => {
                  this.setState({ showWASLRegistration: false });
                }}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>
              <Button htmlType="submit" className="formsSaveButton">
                {this.context.translate("_REGISTER_")}
              </Button>
            </div>
          </Form>
        </Drawer>
        {this.waslCompanyStore?.WASLCompanyStatus && (
          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showAlertModal}
            onOk={() => this.setState({ showAlertModal: false })}
            onCancel={() => this.setState({ showAlertModal: false })}
            okText="OK"
            cancelText="Cancel"
            footer={[
              <Button
                type="primary"
                onClick={() => this.setState({ showAlertModal: false })}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>,
            ]}
          >
            <p>{this.waslCompanyStore?.WASLCompanyStatus}</p>
          </Modal>
        )}

        {this.waslCompanyStore?.inquiryStatus && (
          <Modal
            width={550}
            className="alert-model"
            title={this.context.translate("_INFORMATION_")}
            open={this.state.waslInquiryPopup}
            onOk={() => this.setState({ waslInquiryPopup: false })}
            onCancel={() => this.setState({ waslInquiryPopup: false })}
            okText="OK"
            cancelText="Cancel"
            footer={null}
          >
            <div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <b>{this.context.translate("_REFERENCE_NUMBER_")}:</b>
                <span>{referenceNumber}</span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <b>{this.context.translate("_FLEET_USER_USERLIST_NAME_")}:</b>
                <span>{name}</span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <b>{this.context.translate("_REGISTRATION_DATE_")}:</b>
                <span>{registrationDate}</span>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <b>{this.context.translate("_IS_VALID_")}:</b>
                <span>{isValid ? "True" : "False"}</span>
              </div>
            </div>
            {/* <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <b>Reference Key:</b>
              <span>123456789</span>
            </div>

            <b>Plate Information:</b>
            <span>Right Letter: A</span>
            <span>Middle Letter: B</span>
            <span>Left Letter: C</span>
            <span>Number: 1234</span>
            <span>Vehicle IMEI: 3570729292929</span>

            <h6>Vehicle Location Information:</h6>
            <span>Latitude: 25.2048</span>
            <span>Longitude: 55.2708</span>
            <span>Vehicle Status: Active</span>
            <span>Actual Time: 2025-10-16 12:30:00</span>
            <span>Received Time: 2025-10-16 12:31:10</span>

            <h6>Operating Company Information:</h6>
            <span>Reference Key: 987654321</span>
            <span>Name: SecureTrack</span>
            <span>Is Vehicle Valid: Yes</span>
            <span>Registration Time: 2024-12-20 09:15:00</span>
          </div> */}
          </Modal>
        )}
      </>
    );
  }
}
WASLCompanyList.contextType = StoreContext;
export default observer(withRouter(WASLCompanyList));
